var render = function render(){var _vm=this,_c=_vm._self._c;return _c('advanced-thumbnail-impl',{attrs:{"alt":_vm.altComputed,"background-position":_vm.dataComputed.alignment,"background-size":_vm.backgroundSize,"background-type":_vm.backgroundType,"shadow":false,"thumb":_vm.dataComputed.background_image}})
}
var staticRenderFns = []

export { render, staticRenderFns }